import React from 'react';
import Views from '../views';
import TextNumberView from '../views/textNumber-input/textNumberView';

const TextNumberEntryView = ({title, left, right, ...props}) => {
  return (
    <Views title={title} left={left} right={right}>
      <TextNumberView {...props} />
    </Views>
  );
};

export default TextNumberEntryView;
